import {
  createdByColumnDefinition,
  customGroupNameColumnDefinition,
  itemsStringColumnDefinition,
  publicFlagColumnDefinition,
  updatedByColumnDefinition,
  typeColumnDefinition,
} from '../columnDefinitions';
import { alignLeftCellStyle } from '@common/cellStyles';
import { CUSTOM_GROUP_TYPE_OPTIONS } from '../../administration/customGroupsPage/constants';

export default [
  { ...customGroupNameColumnDefinition, sort: 'asc' },
  {
    ...typeColumnDefinition,
    headerName: 'Custom Group Type',
    field: 'groupType',
    valueGetter: ({ data }) => {
      const foundTypeOption = CUSTOM_GROUP_TYPE_OPTIONS.find(option => option.value === data.groupType);
      if (foundTypeOption) {
        return foundTypeOption.label;
      }
      return 'Standard';
    },
    maxWidth: 100,
    ...alignLeftCellStyle,
  },
  publicFlagColumnDefinition,
  itemsStringColumnDefinition,
  { ...createdByColumnDefinition, maxWidth: 158 },
  { ...updatedByColumnDefinition, maxWidth: 158 },
];
